import type { IRowNode } from 'ag-grid-community'
import type { AgGridReactProps } from 'ag-grid-react'

import { CountStatusBar, type CountStatusBarParams } from './CountStatusBar'

type AggregationFunction = 'sum' | 'min' | 'max' | 'avg'

const DEFAULT_AGGREGATION_FUNCTIONS: AggregationFunction[] = [
  'sum',
  'min',
  'max',
  'avg',
]

export type InventoryStatusBarOptions = {
  countPanelParams?: CountStatusBarParams
  includeAggregationPanel?: boolean
  aggregationFunctions?: AggregationFunction[]
}

const defaultExcludeRow = (node: IRowNode<unknown>): boolean => {
  if (node.group) return true
  return typeof node.id === 'string' && node.id.includes('new')
}

export const createInventoryStatusBarConfig = <Row = unknown>(
  options: InventoryStatusBarOptions = {},
): NonNullable<AgGridReactProps<Row>['statusBar']> => {
  const statusPanels: Array<{
    statusPanel: string | ((props: unknown) => React.ReactNode)
    statusPanelParams?: Record<string, unknown>
  }> = [
    {
      statusPanel: CountStatusBar,
      statusPanelParams: {
        trackedFieldKeys: ['surface', 'volume'],
        excludeRow: defaultExcludeRow,
        ...options.countPanelParams,
      },
    },
  ]

  if (options.includeAggregationPanel ?? true) {
    statusPanels.push({
      statusPanel: 'agAggregationComponent',
      statusPanelParams: {
        aggFuncs: options.aggregationFunctions ?? DEFAULT_AGGREGATION_FUNCTIONS,
      },
    })
  }

  return {
    statusPanels,
  }
}
